<table class="table is-fullwidth is-hoverable">
  <thead />
  <tbody>
    {#each items as item}
      <tr>
        <td>
          <div
            class="is-pulled-left"
            style="width:120px; height:120px; margin-right:20px;"
          >
            <a
              href={$url("../offer/" + item.id)}
              style="display:inline-block;width:120px;"
            >
              {#if item.data.images?.[0]}
                <img
                  alt="Offer"
                  src={item.data.images[0]}
                  style="height:120px;width:120px;object-fit:cover;object-position:center;"
                  loading="lazy"
                />
              {:else}
                <img
                  alt="Generic"
                  src="/assets/img/box.png"
                  style="height:120px;width:120px; background-color:#eee"
                />
              {/if}
            </a>
          </div>
          <div>
            <a href={$url("../offer/" + item.id)}>{item.data.name}</a>
          </div>
          <div class="is-line-clamp-4">{item.data.description}</div>
        </td>
        <td>
          {#if item.data.location}
            <span class="has-text-grey-light" style="white-space: nowrap;">
              {charityLocation ? getDistance(
              {
                latitude: item.data.geo.latitude,
                longitude: item.data.geo.longitude,
              },
              {
                latitude: charityLocation.coordinates[1],
                longitude: charityLocation.coordinates[0],
              }) : ''}
            </span>
          {/if}</td
        >
        <td>
          <span class="tag is-success is-light"
            >{getStatus(requestsByOffer[item.id])}</span
          >
        </td>
      </tr>
    {/each}
  </tbody>
</table>

<script lang="ts">
  export let items :any[], requestsByOffer :any, charityLocation :any;
  import { url } from "@sveltech/routify";
  import getStatus from "../../../utils/getStatus";
  import geoDist from "geo-dist";

  function getDistance(point1 :GeoPoint, point2 :GeoPoint) {
    try {
      console.log([point1, point2]);
      const km = geoDist(
        point1.latitude,
        point1.longitude,
        point2.latitude,
        point2.longitude
      );
      console.log(km);
      const miles = km * 0.6213712; // miles
      if (miles < 1) {
        return "< 1 mile";
        // } else if (miles < 4.5) {
        //   return Number.parseFloat(miles).toFixed(1) + " miles away";
      } else {
        console.log(Math.round(miles).toString(10) + " miles");
        return Math.round(miles).toString(10) + " miles";
      }
    } catch (err) {
      console.log(err);
    }
  }
</script>